import React from 'react'
import styled from 'styled-components'
import { EXAM_TYPE } from '@laputan/core'
import { Dropdown } from '../../Dropdown'
import { TwoColumnFormView } from '../../Form/TwoColumnFormView'
import { VCESchoolResultTabItem } from './VCESchoolResultTabItem'
import { mergeRight } from '../../../lib/ramda'
import { HSCSchoolResultTabItem } from './HSCSchoolResultTabItem'
import { QCAASchoolResultTabItem } from './QCAASchoolResultTabItem'
import { ATARSchoolResultTabItem } from './ATARSchoolResultTabItem'
import { WACESchoolResultTabItem } from './WACESchoolResultTabItem'
import { ISchoolTabItemProps } from './SchoolTabItem.types'

const StyledSchoolResultsTabItem = styled.div`
  min-height: 25rem;
`

const ExamTypeDropdown = styled(Dropdown)``

const SchoolResultTabItem: React.FC<ISchoolTabItemProps> = ({
  results,
  onChange,
}) => {
  if (!results) {
    return null
  }
  const { examType } = results
  const onFieldChange = (field) => {
    onChange(mergeRight(results, field))
  }
  return (
    <StyledSchoolResultsTabItem>
      <ExamTypeDropdown
        labelText="Exam Type"
        items={Object.values(EXAM_TYPE).map((t) => ({
          text: t,
          value: t,
        }))}
        value={examType}
        onChange={(v) => {
          onFieldChange({
            examType: v,
          })
        }}
      />
      <TwoColumnFormView>
        {
          {
            [EXAM_TYPE.VCE]: (
              <VCESchoolResultTabItem
                results={results}
                onChange={onFieldChange}
              />
            ),
            [EXAM_TYPE.HSC]: (
              <HSCSchoolResultTabItem
                results={results}
                onChange={onFieldChange}
              />
            ),
            [EXAM_TYPE.QCAA]: (
              <QCAASchoolResultTabItem
                results={results}
                onChange={onFieldChange}
              />
            ),
            [EXAM_TYPE.ATAR]: (
              <ATARSchoolResultTabItem
                results={results}
                onChange={onFieldChange}
              />
            ),
            [EXAM_TYPE.WACE]: (
              <WACESchoolResultTabItem
                results={results}
                onChange={onFieldChange}
              />
            ),
          }[examType]
        }
      </TwoColumnFormView>
    </StyledSchoolResultsTabItem>
  )
}

export { SchoolResultTabItem }
